import { useAxios } from "@sttedra_ui/framework";

// #region Globals
const { base } = useAxios();
const timeout = 30000;
// #endregion

// #region Public functions
async function getVersion(alias) {
  try {
    const url = `/PowerBI/GetVersion/${alias}`;

    const response = await base.get(url, {
      timeout,
    });

    return response;
  } catch (err) {
    localStorage.setItem("errorToastMessage", "Error al buscar las versiones");

    return err;
  }
}

async function createPbix(params = {}) {
  try {
    const url = `/PowerBI/CreatePbix`;

    const response = await base.post(url, params, {
      timeout: 600000, 
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response;
  } catch (err) {
    localStorage.setItem("errorToastMessage", "Error al subir el archivo PBIX");

    return err;
  }
}

async function uploadPbix(params = {}) {
  try {
    const url = `/PowerBI/UploadPbix`;

    const response = await base.post(url, params, {
      timeout: 600000,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response;
  } catch (err) {
    localStorage.setItem("errorToastMessage", "Error al subir el archivo PBIX");

    return err;
  }
}

async function changeActiveVersion(params = {}) {
  try {
    const url = `/PowerBI/ChangeActiveVersion`;

    const response = await base.put(url, params, {
      timeout,
    });

    return response;
  } catch (err) {
    localStorage.setItem(
      "errorToastMessage",
      "Error al cambiar la versión activa"
    );

    return err;
  }
}

async function deleteVersion(params = {}) {
  try {
    const url = `/PowerBI/DeleteVersion`;

    const response = await base.delete(
      url,
      {
        data: {
          versionToDelete: params.versionToDelete,
          alias: params.alias,
        },
      },
      {
        timeout,
      }
    );

    return response;
  } catch (err) {
    localStorage.setItem(
      "errorToastMessage",
      "Error al borrar el archivo PBIX"
    );

    return err;
  }
}
// #endregion

// #region Private functions
// #endregion

export {
  getVersion,
  createPbix,
  uploadPbix,
  changeActiveVersion,
  deleteVersion,
};
